import { defineStore } from 'pinia'

export const useSnackbarStore = defineStore("snackbar", {
    state: () => ({
        snackbar: false,
        timeout: 2500,
        text: "",
    }),
})